import { useEffect } from 'react';
import './booking-view-checkout.scss';
import { useTranslation } from 'react-i18next';
import {
  useFetchSelectedActivityPayments,
  useSelectedActivityPayments,
} from '../../../store/my-activities/myActivitiesHooks';

type PropsTypes = {
  creditTypes: CreditTypesEnum;
  price: number;
  discount?: number;
  disabledCreditUser?: boolean;
  isPurchasable?: boolean;
  isWaitingListMode?: boolean;
  activityId: number;
};

export enum CreditTypesEnum {
  COMPANY = 'COMPANY',
  USER = 'USER',
}

const BookingViewCheckout = (props: PropsTypes) => {
  const { t } = useTranslation();
  const payments = useSelectedActivityPayments();

  const costAfterDiscount =
    payments.length && payments[0].sum
      ? payments[0].sum
      : // eslint-disable-next-line no-mixed-operators
        props.price -
        // eslint-disable-next-line no-mixed-operators
        props.price * (props?.discount ? props?.discount / 100 : 0);

  return (
    <div className="booking-checkout">
      <div className="total-cost">
        <span className="total-cost-title">{t('PAID_TOTAL_COST')}</span>
      </div>
      <div className="view-screen">
        <span className="booking-total">₪{costAfterDiscount}</span>
        <span className="original-price">₪{props.price}</span>
        <div className="discount_tag">
          {payments.length && payments[0].discount
            ? payments[0].discount
            : props.discount}
          % {t('OFF')}
        </div>
        <div className="checkout-line" />
      </div>
    </div>
  );
};

export default BookingViewCheckout;
